export const environment = {
  production: true,
  recaptcha: {
    siteKey: '6LekGtQsAAAAAIOg8AFPk0GbYFO3luf26sNRaVEs',
  },


  baseUrl: 'https://www.claimform.qvarantitrustsettlement.com/api/'
  /*baseUrl: 'https://qvarantitrustsettlement-claimform-dev.azurewebsites.net/api/'*/
  /*baseUrl: 'https://localhost:7249/api/'*/
};

